import "@shoelace-style/shoelace/dist/components/button/button.js";
import "@shoelace-style/shoelace/dist/components/dialog/dialog.js";
import React from "react";

/**
 * BoardPageTemplate - Template for board-based pages like the Kanban dashboard
 *
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.subtitle - Page subtitle
 * @param {React.ReactNode} props.headerActions - Actions to display in the header
 * @param {React.ReactNode} props.children - Board content
 * @param {boolean} props.loading - Whether the board is loading
 * @param {number} props.totalTasks - Total number of tasks
 */
const BoardPageTemplate = ({
  title,
  subtitle,
  headerActions,
  children,
  loading = false,
  totalTasks = 0,
}) => {
  return (
    <div className="min-h-screen bg-[#0f1418] p-4">
      <div className="max-w-full mx-auto">
        <div className="flex flex-col mb-6">
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold text-gray-100">{title}</h1>
            <div className="flex space-x-2">{headerActions}</div>
          </div>

          {subtitle && (
            <div className="flex justify-between items-center mt-2">
              <p className="text-sm text-gray-400">{subtitle}</p>
              <div className="text-sm text-gray-400">
                Total tasks:{" "}
                <span className="font-medium text-white">{totalTasks}</span>
              </div>
            </div>
          )}
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#4db1e0]"></div>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default BoardPageTemplate;
